import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@material-ui/core';
import useStyles from './styles';
import Button from '../Button';

const ConfirmDialog = ({
  open,
  title = 'Confirmar acción',
  message,
  description,
  onConfirm,
  onCancel,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  // Opcionales para personalizar los botones; sin ellos se usan los estilos
  // por defecto de Button
  buttonWidth,
  confirmBackgroundColor = 'theme-custom-solidButtonBackground',
  confirmColor = 'theme-custom-solidButtonText',
  confirmBorder,
  cancelBackgroundColor,
  cancelColor,
}) => {
  const styles = useStyles();
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>
          {message}
        </Typography>
        {description && (
          <Typography variant="body2" color="textSecondary" className={styles.description}>
            {description}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>

        <Button
          id="save-btn"
          variant="outlined"
          text={cancelText}
          width={buttonWidth}
          backgroundColor={cancelBackgroundColor}
          color={cancelColor}
          borderRadius='10px'
          onClick={onCancel}
        />
        <Button
          id="save-btn"
          variant="outlined"
          text={confirmText}
          width={buttonWidth}
          backgroundColor={confirmBackgroundColor}
          color={confirmColor}
          border={confirmBorder}
          borderRadius='10px'
          onClick={onConfirm}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
